import appsAndPages from './apps-and-pages'

export default appsAndPages
